import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import { StyledModalFooterComponent } from "./modal-footer-component.scss";
class ModalFooterComponent extends PureComponent {
    render() {
        const { footerText } = this.props;
        return /*#__PURE__*/ _jsxs(StyledModalFooterComponent, {
            className: "modal-footer",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "modal-footer-text",
                    children: footerText
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "modal-footer-signup-wrapper",
                    children: /*#__PURE__*/ _jsx(SignupFormComponent, {
                        focusOnLoad: true,
                        placement: "modal_footer"
                    })
                })
            ]
        });
    }
}
export { ModalFooterComponent as default };
